<template>
  <div class="coming-soon">
    <div class="container">
      <div class="instruction">
        <BaseText11 text="New<br>opponents<br>arriving<br>soon"/>
      </div>
      <div class="opponent-image-container">
        <img class="opponent-image" src="@/assets/img/opponent-coming-soon.png">
      </div>
      <div class="gradient"/>
    </div>
  </div>
</template>

<script>
import BaseText11 from '@/components/BaseText11/BaseText11'
export default {
  name: 'coming-soon',
  components: {
    BaseText11
  }
}
</script>

<style lang="scss" scoped>
.coming-soon {
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacing-1) + 1rem);
}
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: var(--spacing-1) var(--spacing-1) calc(var(--spacing-1) * 2);
}
.instruction {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: var(--spacing-1);
}
.opponent-image-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: visible;
  pointer-events: none;
  z-index: -2;
  opacity: 0.7;
}
.opponent-image {
  position: absolute;
  height: 108%;
  bottom: 0;
  left: 95%;
  display: block;
  transform: translateX(-60%);
}
.gradient {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 12rem;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  z-index: -1;
  pointer-events: none;
}
</style>
